const PHRASES = [
  "A Safe Place",
  "A Comfortable Place",
  "A Supportive Place",
  "A Place of Dignity",
  "A Place to Belong",
  "A Place to Call Home",
];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div className="bg-sagelight py-4 overflow-hidden" aria-hidden="true">
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-xl sm:text-2xl text-sage italic px-6 whitespace-nowrap">{p}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-laurel shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
